import { ENTITY, PLACE_SHORT } from '../constants'
import { Stamp } from '../components/Stamp'

const particulars = [
  { label: 'Product', value: 'Compound' },
  { label: 'License', value: 'Per organization' },
  { label: 'Includes', value: 'Skills, support, training' },
  { label: 'Prerequisite', value: 'Cursor' },
  { label: 'Office', value: PLACE_SHORT },
  { label: 'Entity', value: ENTITY },
]

export function CompoundTitleSheet() {
  return (
    <section className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 pt-6 pb-0 lg:px-8 lg:pt-8">
        <div className="cell flex flex-col bg-sheet">
          <div className="border-b border-rule px-5 py-5 sm:px-7 sm:py-7">
            <p className="cell-label mb-3 text-overprint">Product sheet</p>
            <h1 className="sheet-title text-ink">
              The delivery system that learns your project
            </h1>
          </div>

          <div className="grid border-b border-rule lg:grid-cols-[1.35fr_1fr]">
            <div className="space-y-4 border-b border-rule px-5 py-5 sm:px-7 sm:py-6 lg:border-b-0 lg:border-r">
              <p
                className="text-xl font-semibold leading-snug text-ink sm:text-2xl"
                style={{ fontStretch: '88%' }}
              >
                Compound adapts to your codebase, improves with every run, and
                carries work across the full SDLC — from analysis to production
                evidence.
              </p>
              <p className="text-base leading-relaxed text-ink-muted">
                Graph indexing, vector RAG, and semantic search let Compound find
                signal fast inside large codebases — then it reads the backlog,
                writes requirements and specs, sets the delivery plan, implements,
                tests, hunts security issues, runs stage verification and
                pentests, ships manuals and documentation, and triages what
                breaks — getting sharper on{' '}
                <em className="not-italic font-medium text-ink">your</em> terrain
                the longer you use it.
              </p>
            </div>

            <dl className="divide-y divide-rule-faint px-5 py-1 sm:px-7">
              {particulars.map((row) => (
                <div key={row.label} className="py-2.5">
                  <dt className="cell-label text-ink-muted">{row.label}</dt>
                  <dd
                    className="mt-1 text-[0.9375rem] font-medium leading-snug text-ink"
                    style={{ fontStretch: '88%' }}
                  >
                    {row.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="flex flex-wrap items-center gap-5 px-5 py-5 sm:px-7">
            <Stamp
              className="plate plate-over"
              subject="Compound subscription"
              label="Subscribe via"
            />
            <p className="max-w-md text-sm leading-relaxed text-ink-muted">
              Living skills that keep improving, plus support and staff
              training — not a prompt pack, not a chatbot. Method memory updates
              on subscription. Project memory deepens with every run.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
